const createEventBus = () => {
  const listeners = new Map();
  return {
    $on(event, handler) {
      const handlers = listeners.get(event) || new Set();
      handlers.add(handler);
      listeners.set(event, handlers);
    },
    $off(event, handler) {
      if (!listeners.has(event)) return;
      if (!handler) {
        listeners.delete(event);
        return;
      }
      const handlers = listeners.get(event);
      handlers.delete(handler);
      if (handlers.size === 0) {
        listeners.delete(event);
      }
    },
    $emit(event, payload) {
      if (!listeners.has(event)) return;
      listeners.get(event).forEach((handler) => handler(payload));
    },
  };
};

export const eventBus = createEventBus();
